module.exports = __webpack_public_path__ + "img/LogoSinggalang.10d5dfa8.svg";